const proxyRules: Record<string, () => null | {type: string}> = {
	"proquest": () => {
		const url = new URL(window.location.href);

		const matches = /^(?<proquestHost>(pre[\-_.])?congressional[\-_.]proquest[\-_.]com)[\-_.](?<orgHost>.+)/.exec(url.hostname);
		if (!matches?.groups)
			return null;

		let {orgHost} = matches.groups;
		if (url.port)
			orgHost += ":" + url.port;

		// Thanks: https://stackoverflow.com/a/6969486/368864
		const escapedOrgHost = orgHost.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

		return {
			"type":                       "simple",
			"prefix_url":                 url.protocol + "//" + orgHost + "/login?url=",
			"encode_url":                 false,
			"unprefix_regex":             "^https?:\\/\\/" + escapedOrgHost + "\\/login\\?url=(.+)$",
			"protocol_domain_path_regex": "^(https?):\\/\\/([^\\/]+)\\." + escapedOrgHost + "\\/(.+)$"
		};
	}
};

export default proxyRules;
